// import React, { useState, useEffect } from "react";
// import {
//     Dialog,
//     DialogContent,
//     DialogContentText,
//     DialogActions,
//     Button,
// } from "@material-ui/core";
// import featureServer from "../../../../../appUtility/featureServer";
// import { history } from "../../../../../../src/store/index";


// const StockMessage = (props) => {
//     const [details, setDetails] = useState({
//         open: props && props.open,
//     });
//     const [showButton, setShowButton] = useState(false);

//     useEffect(() => {
//         props.sendToStock(details);
//     }, []);


//     const handleDismiss = () => {
//         setDetails({
//             ...details,
//             open: false,
//         });
//         // localStorage.setItem("stock_attention", JSON.stringify("false"));
//     };

//     const handleStockTake = () => {
//         // localStorage.setItem("stock_attention", JSON.stringify("false"));
//         history.push(`/app/inventory/stock_take`);
//     };


//     useEffect(() => {
//         const checkTime = () => {
//             const now = new Date();
//             const options = { 
//                 timeZone: 'Australia/Sydney', 
//                 year: 'numeric', 
//                 month: '2-digit', 
//                 day: '2-digit', 
//                 hour: '2-digit', 
//                 minute: '2-digit', 
//                 second: '2-digit', 
//                 hour12: false 
//             };
//             const formatter = new Intl.DateTimeFormat('en-AU', options);
//             const parts = formatter.formatToParts(now);
//             const dateParts = parts.reduce((acc, part) => {
//                 acc[part.type] = part.value;
//                 return acc;
//             }, {});
    
//             const currentDate = new Date(
//                 `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}+10:00`
//             );
    
//             const day = currentDate.getUTCDate();
            
//             if (day >= 1 && day <= 14) {
//                 setShowButton(true);
//             } else {
//                 setShowButton(false);
//             }
//         };
    
//         checkTime();
//         const intervalId = setInterval(checkTime, 60000);
//         return () => clearInterval(intervalId);
//     }, []);

//     const currentMonth = new Date().toLocaleString('default', { month: 'long' });

//     return (
//         <Dialog maxWidth="md" open={details.open} onClose={false}>
//             <div className="p-2">
//                 <DialogContent>
//                     {/* {featureServer && ( */}
//                     <DialogContentText style={{ color: "#444" }}>
//                     <h3><strong>It’s time to do your quarterly stock take.</strong></h3>
//                     <p>Please action to avoid repetition of this pop-up request.</p>
//                         {/* <h2>Empower Your Pet Grooming Business: Quarterly Stock Take for Unleashed Success!</h2>

//                         <p>Keeping your inventory in check every quarter not only ensures smooth operations but also highlights your commitment to excellence.</p>

//                         <p>Embrace the power of regular stock takes to stay organized, reduce waste, and provide the best for your furry clients.</p>

//                         <p>Let's make each quarter count towards a more efficient and prosperous grooming business!</p> */}


//                         {/* <h1>Introducing Inventory Usage Tracking: A New Feature to Optimize Your Shampoo, Cologne and HydroClean Management</h1>

//                         <p>We are excited to announce that we have added a new feature to our Mate system that helps you track and manage your Shampoo, Cologne and HydroClean usage and orders. Inventory usage tracking is a powerful tool that allows you to monitor how much Shampoo, Cologne and HydroClean you are using, how much Shampoo, Cologne and HydroClean you have left, and how much Shampoo, Cologne and HydroClean you need to order.</p>

//                         <p><strong>Inventory usage tracking can help you:</strong></p>
//                         <ul>
//                             <li>Reduce inventory costs by avoiding overstocking or understocking.</li>
//                             <li>Improve inventory accuracy by tracking inventory movements and adjustments.</li>
//                             <li>Increase inventory efficiency by optimizing inventory replenishment and allocation.</li>
//                             <li>Enhance inventory visibility by generating inventory usage reports and dashboards.</li>
//                         </ul>

//                         <p>This feature will be enabled on <em>1st July 2024</em> automatically and you don’t have to do anything. Once enabled, it will suggest you make a one-time “Stock Take” to estimate how much Shampoo, Cologne and HydroClean you currently have, to predict your next refill timeline.</p>

//                         <p>You can configure your inventory usage per service type via <em>setup -&gt; Inventory usage</em>. This will have default values set by support office which you are free to optimize as per your needs.</p>

//                         <p>We hope you enjoy this new feature and find it useful for your inventory management.</p> */}



//                     </DialogContentText>

//                 </DialogContent>
//                 <DialogActions style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     {showButton &&
//                         <div style={{ marginLeft: "15px" }}><strong>Deadline: 14th {currentMonth}</strong></div>
//                     }
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
//                         <Button variant="contained" color="primary" onClick={handleStockTake}>
//                             Stock Take Now
//                         </Button>
//                         {showButton &&
//                             <Button variant="contained" style={{ marginLeft: "10px" }} color="primary" onClick={handleDismiss}>
//                                 Dismiss
//                             </Button>
//                         }
//                     </div>

//                 </DialogActions>
//             </div>
//         </Dialog>
//     );
// };

// export default StockMessage;


import React, { useState, useEffect } from "react";

import {

    Dialog,

    DialogContent,

    DialogContentText,

    DialogActions,

    Button,

} from "@material-ui/core";

import featureServer from "../../../../../appUtility/featureServer";

import { history } from "../../../../../../src/store/index";
 
// localStorage key used to remember when the modal was last dismissed

const STOCK_MODAL_LAST_SHOWN_KEY = "stock_take_modal_last_shown";
 
const StockMessage = (props) => {

    // Modal starts closed - the checkTime effect below decides if/when it should open

    const [details, setDetails] = useState({

        open: false,

    });

    const [showButton, setShowButton] = useState(false);
 
    // Returns the browser's local wall-clock time as an ISO-like string

    // WITHOUT converting to UTC (no trailing "Z"), so it reflects whatever

    // local time the user's device is actually showing (e.g. Nepal time).

    const getLocalISOString = () => {

        const now = new Date();

        const offsetMs = now.getTimezoneOffset() * 60000;

        const localTime = new Date(now.getTime() - offsetMs);

        return localTime.toISOString().slice(0, -1); // strip the trailing "Z"

    };
 
    const handleDismiss = () => {

        setDetails((prev) => ({

            ...prev,

            open: false,

        }));

        localStorage.setItem(STOCK_MODAL_LAST_SHOWN_KEY, getLocalISOString());

    };
 
    const handleStockTake = () => {

        setDetails((prev) => ({

            ...prev,

            open: false,

        }));

        history.push(`/app/inventory/stock_take`);

    };
 
    // Resolve "now" as a real Date object built from Sydney wall-clock time

    // (kept consistent with the original conversion approach)

    const getSydneyNow = () => {

        const now = new Date();

        const options = {

            timeZone: "Australia/Sydney",

            year: "numeric",

            month: "2-digit",

            day: "2-digit",

            hour: "2-digit",

            minute: "2-digit",

            second: "2-digit",

            hour12: false,

        };

        const formatter = new Intl.DateTimeFormat("en-AU", options);

        const parts = formatter.formatToParts(now);

        const dateParts = parts.reduce((acc, part) => {

            acc[part.type] = part.value;

            return acc;

        }, {});
 
        return new Date(

            `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`

        );

    };
 
    useEffect(() => {

        const checkTime = () => {

            const sydneyNow = getSydneyNow();

            const day = sydneyNow.getDate();

            const withinWindow = day >= 1 && day <= 14;
 
            setShowButton(withinWindow);
 
            // Outside the 1st-14th window: modal is always open, no suppression applied.

            if (!withinWindow) {

                setDetails((prev) => (prev.open ? prev : { ...prev, open: true }));

                return;

            }
 
            // Boundary for "today's" 8AM in the browser's LOCAL time - this must

            // match the timezone the dismiss timestamp is stored in (local, not Sydney).

            const localNow = new Date();

            const todayEightAM = new Date(localNow);

            todayEightAM.setHours(8, 0, 0, 0);
 
            // The active 8AM-to-8AM window started today at 8AM local time, unless

            // it's currently before 8AM, in which case it started yesterday at 8AM.

            const windowStart = new Date(todayEightAM);

            if (localNow < todayEightAM) {

                windowStart.setDate(windowStart.getDate() - 1);

            }
 
            const lastShownRaw = localStorage.getItem(STOCK_MODAL_LAST_SHOWN_KEY);

            const lastShown = lastShownRaw ? new Date(lastShownRaw) : null;

            const alreadyShownInWindow = lastShown && lastShown >= windowStart;
 
            if (!alreadyShownInWindow) {

                setDetails((prev) => ({ ...prev, open: true }));

            }

        };
 
        checkTime();

        const intervalId = setInterval(checkTime, 60000);

        return () => clearInterval(intervalId);

    }, []);
 
    useEffect(() => {

        props.sendToStock(details);

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [details.open]);
 
    const currentMonth = new Date().toLocaleString("default", { month: "long" });
 
    return (
<Dialog maxWidth="md" open={details.open} onClose={false}>
<div className="p-2">
<DialogContent>
<DialogContentText style={{ color: "#444" }}>
<h3><strong>It’s time to do your quarterly stock take.</strong></h3>
<p>Please action to avoid repetition of this pop-up request.</p>
</DialogContentText>
</DialogContent>
<DialogActions style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                    {showButton &&
<div style={{ marginLeft: "15px" }}><strong>Deadline: 14th {currentMonth}</strong></div>

                    }
<div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
<Button variant="contained" color="primary" onClick={handleStockTake}>

                            Stock Take Now
</Button>

                        {showButton &&
<Button variant="contained" style={{ marginLeft: "10px" }} color="primary" onClick={handleDismiss}>

                                Dismiss
</Button>

                        }
</div>
</DialogActions>
</div>
</Dialog>

    );

};
 
export default StockMessage;
 